module.exports = __webpack_public_path__ + "static/media/cat-1.7a9c3576.svg";